<mat-form-field class="form-full-width" appearance="outline" [formGroup]="group">
    <mat-label>{{ field.label }}</mat-label>
    <textarea
        matInput
        (keydown.enter)="$event.stopPropagation()"
        [formControl]="group.get(field.name)"
        [rows]="field.rows ? field.rows : 3"
        [maxlength]="field.maxlength ? field.maxlength : '2000'"
        [id]="field.id ? field.id : null"
        [readonly]="field.disabled"
        [cdkTextareaAutosize]
    >
    </textarea>
    <mat-hint *ngIf="field?.hint" [innerHtml]="field?.hint" class="truncate text-xxs" [title]="field?.hint"></mat-hint>
    <mat-hint *ngIf="field?.maxlength" align="end">
        {{ group?.get(field?.name)?.value?.length }} / {{ field?.maxlength }}
    </mat-hint>
    <fui-button
        *ngIf="group.get(field.name).value && !field.disabled"
        (clickEvent)="group?.get(field.name).setValue(''); group?.get(field.name)?.markAsDirty()"
        matSuffix
        [icon]="'close'"
        [title]="appService.language_dictionary.system_clear"
        [type]="'button-icon'"
        [borderRadius]="'circle'"
        [color]="'neutral'"
        [height]="'mini'"
        [iconSize]="16"
        [disabled]="field.disabled"
    >
    </fui-button>
    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
        <mat-error
            *ngIf="group?.get(field.name)?.hasError(validation.name)"
            [innerHTML]="
                validation.name === 'serverError' ? group?.get(field.name)?.errors?.serverError : validation.message
            "
        >
        </mat-error>
    </ng-container>
</mat-form-field>
